import { Feature, Point } from "geojson";
import { useContext, useMemo } from "react";
import { MapLayerMouseEvent, ViewStateChangeEvent } from "react-map-gl/maplibre";

import { RanaFormContext, convertValueToString, useFormFieldError } from "@nens/ranalib";

export function useRanaFormMapInput(field: string, mapId: string) {
  const { setPartialValues, values, geoProps } = useContext(RanaFormContext);
  const { setBbox, filterGeoByMapBbox, setFilterGeoByMapBbox } = geoProps;

  const error = useFormFieldError(field);
  const value = (values[field] as unknown as Feature<Point> | undefined) ?? null;

  const extra = convertValueToString(value);

  const clearValue = () => setPartialValues({ [field]: null });

  const clickMap = (e: MapLayerMouseEvent) =>
    setPartialValues({
      [field]: {
        type: "Feature",
        geometry: { type: "Point", coordinates: [e.lngLat.lng, e.lngLat.lat] },
        properties: { name: "" },
      },
    });

  const onMoveEnd = (e: ViewStateChangeEvent) => {
    setBbox(e.target.getBounds().toArray().flat() as [number, number, number, number]);
  };

  const bounds: [number, number, number, number] = useMemo(() => {
    const lon = value?.geometry.coordinates[0];
    const lat = value?.geometry.coordinates[1];

    if (lon !== undefined && lat !== undefined) {
      return [lon, lat, lon, lat];
    } else {
      return [-180, -85, 179, 85];
    }
  }, [value]);

  return {
    value,
    error,
    extra,
    clearValue,
    clickMap,
    onMoveEnd,
    filterGeoByMapBbox,
    setFilterGeoByMapBbox,
    bounds,
  };
}
